/* v22 compatible: early redirect handles legacy filtered collection paths */

(() => {
  const slugify = (value = '') => value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const isLegacyFilteredCollectionLink = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      return parts[0] === 'collections' && parts.length >= 3;
    } catch (_) {
      return false;
    }
  };

  const canonicalizeLink = (link) => {
    if (!link?.href || !isLegacyFilteredCollectionLink(link.href)) return;

    const title = link.textContent
      .replace(/[⌄+→]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!title) return;

    const handle = slugify(title);
    if (!handle) return;

    link.href = `/collections/${handle}`;
    link.dataset.tclCanonicalized = 'true';
  };

  const init = () => {
    const scope = document.querySelector('.tcl-site-header') || document;
    scope.querySelectorAll('a[href*="/collections/"]').forEach(canonicalizeLink);

    // Also fix category-hub cards rendered after DOM load.
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('a[href*="/collections/"]')) canonicalizeLink(node);
          node.querySelectorAll?.('a[href*="/collections/"]').forEach(canonicalizeLink);
        }
      }
    });

    observer.observe(document.body, {childList: true, subtree: true});
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


// v23 performance: re-scan newly rendered navigation/category links without page fetches.
(() => {
  const rescan = () => {
    document.querySelectorAll('a[href*="/collections/"]').forEach((link) => {
      try {
        const url = new URL(link.href, location.origin);
        const parts = url.pathname.split('/').filter(Boolean);
        if (parts[0] !== 'collections' || parts.length < 3) return;

        const title = link.textContent
          .replace(/[⌄+→]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/&/g, ' ')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');

        if (title) link.href = `/collections/${title}`;
      } catch (_) {}
    });
  };

  document.addEventListener('DOMContentLoaded', rescan);
  document.addEventListener('shopify:section:load', rescan);
})();
